import { useState } from 'react';
import { AppBar, Box, Button, Container, IconButton, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { profile } from '../../data/profile';

export const SECTIONS = [
    { id: 'perfil', label: 'Perfil' },
    { id: 'formacion', label: 'Formación' },
    { id: 'experiencia', label: 'Experiencia' },
    { id: 'habilidades', label: 'Habilidades' },
    { id: 'proyectos', label: 'Proyectos' },
    { id: 'contacto', label: 'Contacto' },
    { id: 'ubicacion', label: 'Ubicación' },
];

export default function SiteNavbar() {
    const [anchor, setAnchor] = useState(null);

    return (
        <AppBar position="sticky" elevation={0} sx={{ bgcolor: 'rgba(11,18,32,0.92)', backdropFilter: 'blur(8px)' }}>
            <Container maxWidth="lg">
                <Toolbar disableGutters sx={{ minHeight: 64 }}>
                    <Typography component="a" href="#inicio" variant="h6"
                        sx={{ color: 'inherit', textDecoration: 'none', flexGrow: 1, fontWeight: 800 }}>
                        {profile.name}<Box component="span" sx={{ color: 'primary.light' }}>.</Box>
                    </Typography>

                    <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5 }}>
                        {SECTIONS.map((s) => (
                            <Button key={s.id} href={`#${s.id}`} sx={{ color: 'rgba(255,255,255,0.85)' }}>
                                {s.label}
                            </Button>
                        ))}
                    </Box>

                    <IconButton aria-label="Abrir menú" color="inherit" onClick={(e) => setAnchor(e.currentTarget)}
                        sx={{ display: { xs: 'inline-flex', md: 'none' } }}>
                        <MenuIcon />
                    </IconButton>
                    <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
                        {SECTIONS.map((s) => (
                            <MenuItem key={s.id} component="a" href={`#${s.id}`} onClick={() => setAnchor(null)}>
                                {s.label}
                            </MenuItem>
                        ))}
                    </Menu>
                </Toolbar>
            </Container>
        </AppBar>
    );
}
